import { z } from "zod/v4";

import { IgMetafieldSchema } from "../../../schemas/metafield";

export const GetMetafieldRequestQueryParamSchema = z.object({
  type: z.enum(["product", "variant"]),
  id: z.string(),
  key: z.string(),
});
export type GetMetafieldRequestQueryParamType = z.infer<
  typeof GetMetafieldRequestQueryParamSchema
>;

export const GetMetafieldResponseBodySchema = z.object({
  metafield: IgMetafieldSchema.nullish(),
});
export type GetMetafieldResponseBodyType = z.infer<
  typeof GetMetafieldResponseBodySchema
>;
